import React, { useState } from 'react';
import { UrgencyBanner } from '../components/UrgencyBanner';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { StorySection } from '../components/StorySection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatsInside } from '../components/WhatsInside';
import { ValueStack } from '../components/ValueStack';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
function WaveDivider({
  fromColor,
  toColor
}: {
  fromColor: string;
  toColor: string;
}) {
  const fillMap: Record<string, string> = {
    'bg-cream': '#FAF6F0',
    'bg-white': '#FFFFFF',
    'bg-warmWhite': '#FDFBF8',
    'bg-navy': '#1C3144',
    'bg-teal': '#1A3C34'
  };
  return <div className={`relative h-16 md:h-24 ${toColor} -mt-1`} data-id="element-375">
      <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className={`absolute top-0 left-0 w-full h-full ${fromColor}`} style={{
      transform: 'translateY(-1px)'
    }} data-id="element-376">
        <path d="M0,0 L1440,0 L1440,60 Q1080,120 720,60 Q360,0 0,60 Z" fill={fillMap[toColor] || '#FAF6F0'} data-id="element-377" />
      </svg>
    </div>;
}
export function SalesPage() {
  return <div className="min-h-screen bg-white font-body selection:bg-gold selection:text-white" data-id="element-378">
      <UrgencyBanner data-id="element-379" />
      <HeroSection data-id="element-380" />
      <WaveDivider fromColor="bg-navy" toColor="bg-cream" data-id="element-381" />
      <PainSection data-id="element-382" />
      <WaveDivider fromColor="bg-cream" toColor="bg-warmWhite" data-id="element-383" />
      <StorySection data-id="element-384" />
      <SolutionSection data-id="element-385" />
      <WaveDivider fromColor="bg-teal" toColor="bg-cream" data-id="element-386" />
      <WhatsInside data-id="element-387" />
      <ValueStack data-id="element-388" />
      <Testimonials data-id="element-389" />
      <Guarantee data-id="element-390" />
      <FAQ data-id="element-391" />
      <FinalCTA data-id="element-392" />
      <Footer data-id="element-393" />
    </div>;
}